import { ThemeUIStyleObject } from 'theme-ui';

export const headerContainerStyles: ThemeUIStyleObject = {
  position: 'sticky',
  top: 0,
  zIndex: 100,
  bg: 'neutral/000',
  borderBottom: '1px solid',
  borderColor: 'neutral/300',
  px: ['1rem', '5rem'],
  py: ['0.75rem', '0'],
  height: ['auto', '4rem'],
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: ['0.75rem', '0'],
  flexDirection: ['column', 'row'],
};

// Desktop-specific sections
export const leftSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '2rem',
  flex: 1,
};

export const filtersSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '1rem',
  flexDirection: 'row',
};

export const rightSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '0.75rem',
};

// Shared component wrappers
export const searchInputWrapperStyles: ThemeUIStyleObject = {
  flex: ['6', '1'],
  minWidth: 0,
};

export const filterToggleStyles: ThemeUIStyleObject = {
  flex: ['4', '0 0 auto'],
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '0.875rem',
  color: 'neutral/700',
  minWidth: '10rem',
};

export const resultsTextStyles: ThemeUIStyleObject = {
  fontSize: ['0.625rem', '0.75rem'],
  textAlign: ['left', 'center'],
  color: 'neutral/600',
};

// Mobile-specific rows
export const mobileTopRowStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const mobileFiltersRowStyles: ThemeUIStyleObject = {
  width: '100%',
  gap: '0.5rem',
  alignItems: 'center',
};
